import { FC } from 'react';
import { DeleteIcon } from '@icons';

import { ConfirmationModal } from '@components/index';

interface DeleteConfirmationModalProps {
  showDeleteModal: boolean;
  handleConfirmDelete: () => void;
  handleCancel: () => void;
  title: string;
  message: string;
  isConfirmButtonLoading?: boolean;
}

const DeleteConfirmationModal: FC<DeleteConfirmationModalProps> = ({
  showDeleteModal,
  handleCancel,
  handleConfirmDelete,
  title,
  message,
  isConfirmButtonLoading = false
}) => (
  <ConfirmationModal
    isOpen={showDeleteModal}
    title={title}
    message={message}
    confirmButtonLabel="Delete"
    ModalIcon={DeleteIcon}
    handleCancel={handleCancel}
    handleConfirm={handleConfirmDelete}
    className="max-w-314"
    confirmButtonLabelStyle="!text-errorLite3"
    cancelButtonStyle="text-content"
    confirmButtonStyle="text-error"
    isConfirmButtonLoading={isConfirmButtonLoading}
  />
);

export default DeleteConfirmationModal;
